module.exports = __webpack_public_path__ + "img/bg.9a34efd0.png";